export default __webpack_public_path__ + "static/media/triangle_arrow_right.17a928c0.svg";